import { AuthN, getConfig } from '@seek/online-identity';

const getAuthN = (): AuthN => {
  const clientConfig = getConfig('seekAnz-hirer', window.location);
  return new AuthN(clientConfig);
};

const createAuthService = () => {
  const isServerRendering = typeof window === 'undefined';

  // isServerRendering check needed to run locally
  const authN = isServerRendering ? ({} as AuthN) : getAuthN();

  const login = async (): Promise<null> => {
    await authN.login();
    return null;
  };

  const getToken = async (): Promise<string | null> => {
    const isAuthenticated = await authN.isAuthenticated();

    if (!isAuthenticated) {
      return login();
    }

    const token: string | void = await authN.getToken();

    if (typeof token === 'string') {
      return token;
    }
    return null;
  };

  return {
    login,
    getToken,
  };
};

export { createAuthService };
